/* Colour swatches on the product cards.
 * Tapping one swaps the card photo and repoints the card at that variant.
 * Progressive enhancement: with JS off the swatches are inert but the card
 * still links to the product.
 */
(function () {
  'use strict';

  function wire(card) {
    if (card.dataset.lkCardReady === 'true') return;
    card.dataset.lkCardReady = 'true';

    var swatches = card.querySelectorAll('[data-lk-sw]');
    if (!swatches.length) return;

    var img = card.querySelector('.lk-card__main');
    var links = card.querySelectorAll('[data-lk-link]');

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function (event) {
        event.preventDefault();

        swatches.forEach(function (o) {
          o.classList.toggle('is-on', o === sw);
          o.setAttribute('aria-pressed', o === sw ? 'true' : 'false');
        });

        var src = sw.dataset.img;
        if (img && src) {
          img.removeAttribute('srcset');
          img.src = src;
        }

        var url = sw.dataset.url;
        if (url) {
          links.forEach(function (a) { a.href = url; });
        }
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-lk-card]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
